import { render, staticRenderFns } from "./personal_data.vue?vue&type=template&id=1580aa0a&scoped=true&"
import script from "./personal_data.vue?vue&type=script&lang=js&"
export * from "./personal_data.vue?vue&type=script&lang=js&"
import style0 from "./personal_data.vue?vue&type=style&index=0&id=1580aa0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580aa0a",
  null
  
)

component.options.__file = "personal_data.vue"
export default component.exports